// extracted by mini-css-extract-plugin
module.exports = {"container":"_2CjPO","innerContainer":"_1I7iY","title":"_1E3lj","body":"_24EeM","button":"_2YqQ1","isMuted":"_84fqG"};